/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:72d19235-7a7a-4473-8680-35e247cce564",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_UuFPCRz9w",
    "aws_user_pools_web_client_id": "7q4ja7j65b1j9oll36tbnl6s79",
    "oauth": {
        "domain": "trustminder.auth.eu-west-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "s3fileuploadbd332c9ecf84458b9a759a3017bc8ee385516-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "campaignsapi",
            "endpoint": "https://e5k3e6i36c.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
